// Счётчик активных загрузок lazy-чанков (экраны и шиты). Полоска прогресса
// (RouteProgressBar) подписывается через useSyncExternalStore и показывается,
// пока хоть один чанк в полёте.

let activeCount = 0
const listeners = new Set<() => void>()
// Временная dev-only задержка для визуальной проверки route/sheet preload UX.
const DEBUG_CHUNK_LOAD_DELAY_MS: number | null = null

function emit() {
  for (const listener of listeners) listener()
}

function waitForDebugDelay(): Promise<void> {
  if (DEBUG_CHUNK_LOAD_DELAY_MS === null) return Promise.resolve()

  return new Promise((resolve) => setTimeout(resolve, DEBUG_CHUNK_LOAD_DELAY_MS))
}

export const chunkLoadStore = {
  subscribe(listener: () => void) {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  },

  getSnapshot(): number {
    return activeCount
  },

  // Оборачивает промис загрузки чанка: инкремент на старте, декремент по завершении (включая ошибку).
  track<T>(promise: Promise<T>): Promise<T> {
    activeCount += 1
    emit()

    const done = () => {
      activeCount -= 1
      emit()
    }

    const trackedPromise = Promise.all([promise, waitForDebugDelay()]).then(([result]) => result)
    trackedPromise.then(done, done)

    return trackedPromise
  },
}
